<template><div><h1>VUX V2.5.8 released</h1>
<h2><a href="/en/components/confirm.html">Confirm</a></h2>
<ul><li>[feature] Support method:setInputValue for plugin #1846</li>
</ul>
<h2><a href="/en/components/inline-calendar.html">InlineCalendar</a></h2>
<ul><li>[fix] fix on-change event fires twice #1847</li>
</ul>
<h2><a href="/en/components/popup-picker.html">PopupPicker</a></h2>
<ul><li>[fix] prevent background scrolling when popup is show #1830</li>
</ul>
<h2><a href="/en/components/toast.html">Toast</a></h2>
<ul><li>[fix] Toast's zIndex should be higher than XDialog's #1820</li>
</ul>
<h2><a href="/en/components/x-address.html">XAddress</a></h2>
<ul><li>[feature] Add prop:show to control visibility</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.5.8 released | VUX - Vue.js Mobile UI Component Framework","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.5.8-121.vue?d2543ed4